import { Skeleton } from "@/components";
import { mockArrUuid } from "@/libraries/helper";

interface ListSkeletonProps {
	/**
	 * Number of items to render
	 * @default 5
	 */
	length?: number;
}

const ListSkeleton = (props: ListSkeletonProps) => {
	const items = mockArrUuid(props.length ?? 5);
	return (
		<div className="relative container h-full space-y-4 py-4">
			{items.map((item) => (
				<Skeleton key={item} className="w-full h-28" />
			))}
		</div>
	);
};

export default ListSkeleton;
